import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';

import CloseIcon from '@svg/close.svg';
import { Button } from '@ui/Button';

import s from './AnimatedPageBanner.sss';

interface Props {
  rootClassName?: string,
  containerClassName?: string,
  isVisible?: boolean,
  onClose: () => void,
}

export const AnimatedPageBanner: React.FC<React.PropsWithChildren<Props>> = ({
  rootClassName,
  containerClassName,
  isVisible = true,
  onClose,
  children,
}) => (
  <div className={classNames(s.root, rootClassName)}>
    <CSSTransition
      in={isVisible}
      appear={true}
      timeout={1000}
      classNames={{
        appear: s.appear,
        appearActive: s.appearActive,
        enter: s.enter,
        enterActive: s.enterActive,
        exit: s.exit,
        exitActive: s.exitActive,
      }}
      unmountOnExit={true}
    >
      <div className={classNames(s.container, containerClassName)}>
        <Button
          className={s.close}
          theme="text"
          onClick={onClose}
        >
          <CloseIcon
            width="24"
            height="24"
          />
        </Button>

        {children}
      </div>
    </CSSTransition>
  </div>
);
